/*
 * Custom wishlist — lightweight localStorage toggle for product-card hearts.
 * TODO(prod): replace with a real backend (Storefront API + customer accounts) for persistence
 * across devices. This MVP persists per-browser only.
 */
(function () {
  var KEY = 'houseofheels:wishlist';

  function load() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function save(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable — ignore */
    }
  }

  function sync() {
    var list = load();
    document.querySelectorAll('.custom-card__wishlist').forEach(function (btn) {
      var id = btn.dataset.productId;
      var on = id && list.indexOf(id) > -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.classList.toggle('is-active', on);
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.custom-card__wishlist');
    if (!btn) return;
    e.preventDefault();
    var list = load();
    var id = btn.dataset.productId;
    if (!id) return;
    var i = list.indexOf(id);
    if (i > -1) {
      list.splice(i, 1);
    } else {
      list.push(id);
    }
    save(list);
    sync();
  });

  if (document.readyState !== 'loading') {
    sync();
  } else {
    document.addEventListener('DOMContentLoaded', sync);
  }
})();
